"use strict";
import { stringify } from "qs";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useUrlContext } from "uniswap/src/contexts/UrlContext";
export function useLocationLinkProps(locale) {
  const location = useLocation();
  const { useParsedQueryString } = useUrlContext();
  const qs = useParsedQueryString();
  return useMemo(
    () => !locale ? {} : {
      to: {
        ...location,
        search: stringify({ ...qs, lng: locale })
      }
    },
    [location, qs, locale]
  );
}
